<div mat-dialog-title>
  <h1 class="title-dialog">{{ demo?.name }}</h1>
  <button mat-icon-button mat-dialog-close [disableRipple]="true">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="dialog-content">
  <div class="container-inner-template" *ngIf="!loading; else loadingSpinner">
    <div class="popup-body">
      <div class="info-container">
        <brd-carousel-viewer [carouselSource]="carouselObs$" [startFullScreen]="startFullScreen"></brd-carousel-viewer>
        <div class="description-container">
          <div class="description">
            {{ demo?.description }}
          </div>
          <div class="tags-container" *ngIf="materials.length">
            <div class="title">Enablement material</div>
            <div class="tags">
              <a [href]="material.url" target="_blank" class="materials" *ngFor="let material of materials">
                <mat-icon svgIcon="material-link-24"></mat-icon><span>{{ material.name }}</span>
              </a>
            </div>
          </div>
          <div class="tags-container">
            <div class="title">Applicable industries</div>
            <div #industriesChips class="tags expandable">
              <ng-container *ngIf="industries.length; else noIndustries">
                <mat-chip class="industries" *ngFor="let industry of industries">{{ industry }}</mat-chip>
              </ng-container>
              <ng-template #noIndustries>
                <mat-chip class="industries">Non Classifiable</mat-chip>
              </ng-template>
            </div>
            <div *ngIf="industriesExpandable">
              <brd-button color="no-border" text="See more" (click)="industriesChips.classList.toggle('expanded')"></brd-button>
            </div>
          </div>
        </div>
      </div>
      <div class="module-container">
        <mat-accordion class="module-accordion" *ngIf="modules.length" [multi]="true" togglePosition="before" displayMode="flat">
          <mat-expansion-panel class="module-panel" *ngFor="let module of modules">
            <mat-expansion-panel-header>
              <mat-panel-title class="module-title"> {{ module.name }} </mat-panel-title>
            </mat-expansion-panel-header>
            <brd-demo-popup-module
              [description]="module.description"
              [useCases]="module.useCases ?? []"
              [functionalities]="module.functionalities ?? []"
            ></brd-demo-popup-module>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
    <div class="popup-action">
      <div class="action-info">
        <div>
          Last updated on <strong>{{ lastUpdate | date: "MM/dd/yyyy" }}</strong>
        </div>
        <div>
          Demo version <strong>{{ demo?.version }}</strong>
        </div>
      </div>
      <brd-button
        *ngIf="canAddToCollection"
        color="primary"
        iconName="plus-16"
        text="add to collection"
        (click)="clickButton($event)"
      ></brd-button>
    </div>
  </div>
</div>
<ng-template #loadingSpinner>
  <div class="container-spinner">
    <mat-progress-spinner diameter="80" mode="indeterminate" strokeWidth="5" color="primary"></mat-progress-spinner>
  </div>
</ng-template>
